<div id="overlay" class="overlay" [class.hidden]="!contextMenuOpen" (click)="closeContextMenu()">
    <div id="contextMenu" class="context-menu"
        style="left: {{positionX}}px; top: {{positionY}}px;"
    >
        <router-outlet name="context-menu"></router-outlet>
    </div>
</div>
